/**************************************************
 * Nombre:       Formulario_Lista_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {
    AccountCircle,
    BadgeOutlined,
    CakeOutlined,
    Flag,
    Mail,
    MapsHomeWorkOutlined,
    SignpostOutlined,
    SmartphoneOutlined
} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import IngresoFecha from "../../Modulo_formularios/Componentes/IngresoFecha";
import {useEffect, useState} from "react";
import {obtenerCol} from "../../Servicios/BD/obtenerCol";
import {obtenerEstados} from "../../Modulo_EnviosT1/Funciones/obtenerEstados";
import {obtenerProvincia} from "../../Modulo_EnviosT1/Funciones/obtenerProvincia";
import {obtenerCodigoPostal} from "../../Modulo_EnviosT1/Funciones/obtenerCodigoPostal";

const Formulario_Direccion = ({...props}) => {



    useEffect(() => {


        let prov = props.props.getValues('municipio')
        if (prov) {
            props.props.setValue('codigoDestino', obtenerCodigoPostal(prov))
        }


    }, [props.props.watch('municipio')]);
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography>Datos personales</Typography>
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={AccountCircle} nombre={'Nombre'} dato={'nombres'} {...props}
                                  requerido={'Campo requerido'}/>
                </Grid>


                <Grid container size={6}>
                    <IngresoTexto Icono={BadgeOutlined} nombre={'Apellidos'} dato={'apellidos'} {...props} />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={SmartphoneOutlined} nombre={'Celular'} dato={'celular'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={Mail} nombre={'Correo'} dato={'correo'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>

                <Grid container size={6}>
                    <Typography sx={{fontSize: 16, fontWeight: 600, lineHeight: 1.1}}>
                        ¿Que tan añejo eres?
                    </Typography>
                </Grid>

                <Grid container size={6}>
                    <IngresoFecha Icono={CakeOutlined} nombre={'Cumpleaños'} dato={'fechaCumple'}{...props}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography>Datos de entrega</Typography>
                </Grid>

                <Grid container size={6}>
                    <IngresoSelect Icono={Flag} nombre={'Estado'} dato={'estadoMexico'} {...props}
                                   opciones={obtenerEstados()}
                                   requerido={'Campo requerido'}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoSelect Icono={Flag} nombre={'Municipio'} dato={'municipio'} {...props}
                                   opciones={obtenerProvincia(props.props.getValues('estadoMexico'))}
                                   requerido={'Campo requerido'}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={MapsHomeWorkOutlined} nombre={'Colonia o Localidad'}
                                  dato={'barrio'} {...props} />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={SignpostOutlined} nombre={'Nombre de Calle'}
                                  dato={'calle'} {...props} />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={MapsHomeWorkOutlined} nombre={'Número exterior/interior'}
                                  dato={'numero'} {...props} />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto lineas={4} nombre={'Referencias adiciónales'} dato={'referencia'} {...props} />
                </Grid>

                <Grid container size={12} sx={{px: 1}}>
                    <Typography sx={{
                        fontSize: 12,
                        fontWeight: 400,
                        lineHeight: 1.1
                    }}>{`**Al realizar el pedido apruebas nuestra política de tratamiento de datos y de compras.`}</Typography>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Direccion